import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataBoolean,
} from "pbas-vue-components";
import { translate } from "../trans";
import { translate2 } from "../trans2";
import store from "@/store";

const PensionRegulatorsHeaders = [
  new ODataHeader({
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "views.downloadcenter.icon",
    type: new ODataString("IconBase64", {
      getString: (item) => {
        return item.IconBase64;
      },
      getHtml: (item, type) => {
        return `<img src='${type.getString(
          item,
        )}' alt='Pension Regulator Icon' height='30px' />`;
      },
    }),
    sortable: false,
    visible: true,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Current/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.description",
    type: new ODataString("Current/Translations[]/Label", {
      getString: (item) => {
        return translate2(item.Current, "Label");
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.pension_regulators.act",
    type: new ODataString("Current/Translations[]/Act", {
      getString: (item) => {
        return translate2(item.Current, "Act");
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("Province/Id"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Province/Code"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Province/Name"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Province/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.province",
    type: new ODataString("Province/Translations[]/DisplayValue", {
      getString: (item) => {
        const lang = store.getters["common/language"];
        return translate(item.Province, lang.language);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "Province/Name",
  }),
  new ODataHeader({
    title: "headers.taxes.is_federal",
    type: new ODataBoolean("IsFederal"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.pension_regulators.original_date",
    type: new ODataDate("OriginalDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.pension_regulators.reform_date",
    type: new ODataDate("Current/EffectiveDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("CurrentLinks[]/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("CurrentLinks[]/Translations[]/Link"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.pension_regulators.links",
    type: new ODataString("CurrentLinks[]/Translations[]/Name", {
      getString: function(item) {
        return item.CurrentLinks.map((l) => {
          // console.log(o);
          return l.Translations.map((o) => {
            return (
              o.LanguageCode +
              ' : <a href="' +
              o.Link +
              '" target="_blank">' +
              o.Name +
              "</a>"
            );
          }).join("\n");
        }).join("\n");
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 250px;  min-width: 150px '>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    sortable: false,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    version: 1,
  }),
  new ODataHeader({
    type: new ODataBoolean("HasHistory"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
];
export default PensionRegulatorsHeaders;
